import { useForm } from "react-hook-form";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Grid, TextField } from "@material-ui/core";
import { basic, validationMessages } from '../../../config/validations';
import {IconSelector} from "../../atoms/IconSelectorV2";
import { invokePostService } from '../../../store/global/actions';
import { findRelativePosition } from '../../../services/reactFlowService';
import { findIconSource, generateIconFileName, validateNonAsciiChars } from "../../../utils/commonUtils";

export const CreateAnalyticsForm = (props) => {
    const { onClose, onCompletion, clusterletDetails, clusterletType } = props;
    
    const dispatch = useDispatch();
    const [icon, setIcon] = useState(null);
    const [noIcon, setNoIcon] = useState('')
    const [loading, setLoading] = useState(false);
    

    const { register, handleSubmit, formState: { errors }, setError, watch } = useForm();

    const nameValue = watch("name");

    const messages = { ...validationMessages };


    const onCreate = ({ name, description }) => {
        clusterletDetails.name = name;
        clusterletDetails.attributes.desc = description;

        if (icon == null) {
            setNoIcon('Please select an icon')
            return false
        }
        clusterletDetails.icon = generateIconFileName(icon);
        clusterletDetails.iconSource = findIconSource(icon);
        clusterletDetails.includeInViewMetaJson = true;

        const position = findRelativePosition(clusterletDetails.position, clusterletDetails.type);
        clusterletDetails.position = position;

        setLoading(true);

        dispatch(invokePostService('createClusterlet', {clusterlet: clusterletDetails, clusterletType})).then(res => {
            setLoading(false);
            if (res?.status) {
                onCompletion(true);
            }else {
                if ( res?.code === "600") {
                    res?.errors?.forEach(error => {
                        setError(error.name, {message: error.message});
                    });
                }
            }
        })
    }

    // To remove the icon not selected warning, once the icon is selected
    useEffect(() => {
        if(icon){
            setNoIcon("");
        }
    }, [icon])

    return (
        <Grid id={"create_clusterlet_form"} container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="description"
                    type={"text"}
                    fullWidth
                    multiline={true}
                    rows={4}
                    label={"Description"}
                    placeholder={""}
                    variant="outlined"
                    name="description"
                    inputRef={register({ required: false, validate: validateNonAsciiChars})}
                    error={errors?.description}
                    helperText={errors?.description?.message || ''}
                />
            </Grid>

            <Grid item xs={12}>
                <IconSelector setSelectedIcon={setIcon} selectedIcon={icon} defaultSearchTag={nameValue}/>
            </Grid>

            {noIcon != '' && 
            <Grid id={"no_icon_selected"} item xs={12} style={{ color: 'red', marginTop: '-5px' }}>
                <p style={{font: 'inherit'}} >{noIcon}</p>
            </Grid>}



            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={onClose} color="primary" variant="outlined" style={{ marginLeft: 10 }}>
                    Cancel
                </Button>
                <Button disabled={loading} onClick={handleSubmit(onCreate)} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                    {loading ? 'Creating..' : 'Create'}
                </Button>
            </Grid>
        </Grid>
    );

}